import addUser from '@/components/User/addUser/addUser.vue'
import modalEditUser from '@/components/User/editUser/editUser.vue'
import editIcon from '@/components/Icons/Edit/Edit.vue'
import deleteIcon from '@/components/Icons/Delete/Delete.vue'
import { async } from 'q';
import alerts from '@/components/Alert/Alert.vue'
import modalConfirm from '@/components/Tools/Confirm/Confirm.vue';

export default {
  name: 'User',

  components: {
    addUser,
    modalEditUser,
    editIcon,
    deleteIcon,
    alerts,
    modalConfirm
  },

  data() {
    return {

      alert_temp: {
        status: false,
        label: "",
        type: ""
      },

      modal_confirm: {
        status: false,
        title: "",
        text: "",
        question: "",
        callback: ""
      },
      _id_toDelete: "",
      editUser_id: "",

      addUserFlag: false,
      modal_addUser: false,
      modal_editUser: false,

      /**   FILTERS   */
      tempSelect: "Selecciona...",
      typeSelectFlag: false,
      options: [
        { label: 'Alfabéticamente', value: 'alpha' },
        { label: 'Tipo de Usuario', value: 'type' }
      ],

      search: "",

      // --- ADD USER ---
      createUser: {
        name: "",
        type: "",
        email: "",
        password: ""
      },

      editUserData: {},

      items: [
        {
          'id': '1',
          'name': 'edgar',
          'email': 'prueba@p.com',
          'type': 'admin',
          'actions': 'actions',
        },
        {
          'id': '2',
          'name': 'edgar',
          'email': 'prueba@p.com',
          'type': 'admin',
          'actions': 'actions',
        },
        {
          'id': '3',
          'name': 'edgar',
          'email': 'prueba@p.com',
          'type': 'admin',
          'actions': 'actions',
        },
      ],
      columns: [
        { label: 'Usuario', name: 'name' },
        { label: 'Correo Eléctronico', name: 'email' },
        { label: 'Tipo de Usuario', name: 'type' },
        { label: 'Acciones', name: 'action' },
        // 'Usuario', 'Correo Eléctronico', 'Tipo de Usuario', 'Acciones'
      ],
      baseUrl: "",
      baseUrl_tools: "",
      baseUrl_public: ""

    }
  },

  methods: {
    actions(id) {
      this.errors.clear();
      (async () => {
        this.editUser_id = id;

        await fetch('https://sandbox.api.salonacme.com/manager/get_user_admin', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            _id: this.$session.get('_id'),
            _id_user: this.editUser_id
          })
        }).then(async response => {
          response = await response.json();
          if (response.status) {
            this.modal_editUser = true;
            this.editUserData = response.user;
          } else {
            alert(response.msg);
          }
        })
          .catch(error => alert(error));

      })();

    },
    actionDelete_confirm(_id) {
      this._id_toDelete = _id;
      this.modal_confirm = {
        title: "Usuarios",
        text: "Confirma tu accion.",
        question: "¿Eliminar Usuario?",
        callback: "actionDelete",
        status: false
      }; this.modal_confirm.status = true;
    },
    actionDelete(id) {
      this.errors.clear();
      (async () => {
        var _id = id;

        if (String(_id) == String(this.$session.get('_id'))) {
          // alert(' NO PUEDES AUTOELIMINARTE (-.-) ');
          /** Alert */
          this.alert_temp = {
            status: true,
            type: "danger",
            label: " NO PUEDES AUTOELIMINARTE (-.-) "
          };
          setTimeout(() => { this.alert_temp.status = false; }, 3000);
          /** FIN Alerta */
          return;
        }

        // var res = confirm("Seguro de borrar este usuario?, esta accion no tiene vuelta atras.");
        if (true) {
          // fetch delete user
          await fetch('https://sandbox.api.salonacme.com/manager/delete_user', {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              _id: this.$session.get('_id'),
              _id_user_to_delete: _id
            })
          }).then(async response => {
            response = await response.json();
            if (response.status) {
              /** Alert */
              this.alert_temp = {
                status: true,
                type: "success",
                label: "Usuario Eliminado"
              };
              setTimeout(() => { this.alert_temp.status = false; }, 3000);
              /** FIN Alerta */
              this.get_users();
            } else {
              alert(response.msg);
            }

          })
            .catch(error => alert(error));
        }

      })();
    },
    get_users(order = null, search = null) {

      (async () => {

        await fetch('https://sandbox.api.salonacme.com/manager/get_users_admin', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            _id: this.$session.get('_id'),
            order: order,
            search: search
          })
        }).then(async response => {
          response = await response.json();
          if (response.status) {
            this.items = response.users;
          } else {
            alert(response.msg);
          }

        })
          .catch(error => alert(error));

      })();

    },
    callOrder(order) {
      this.get_users(order);
    },
    searchF() {
      this.get_users(null, this.search);
    },
    confirms(opc) {
      switch (opc) {
        case "actionDelete":
          if (this.modal_confirm.response) {
            this.actionDelete(this._id_toDelete);
          } else {
            this._id_toDelete = "";
          }
          break;

        default:
          break;
      }
    }
  },

  mounted() {
    this.get_users();
    this.baseUrl = this.$parent.baseUrl;
    this.baseUrl_public = this.$parent.baseUrl_public;
    this.baseUrl_tools = this.$parent.baseUrl_tools;
  }


}
